//import css from './css/GeofenceActionsModal.module.css';

import {faCopy, faTrashCan} from "@fortawesome/free-solid-svg-icons";
import IconButton from "components/IconButton";
import {Col, Container, FormControl, FormLabel, Modal, Row} from "react-bootstrap";
import React from "react";
import ExtrasComponent from "../../ExtrasComponent";

const GeofenceActionsModal = ({geofence, show, onHide, onDelete, onCopy}) => {

    if(!geofence)
        return null;

    return (
        <Modal centered show={show} onHide={onHide}>
            <Modal.Header className='modal-header' closeButton>
                <Modal.Title>{geofence.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    {geofence.note &&
                        <Row>
                            <Col>
                                <FormLabel>Note</FormLabel>
                                <FormControl as='textarea' value={geofence.note} readOnly style={{maxHeight: "150px"}}/>
                            </Col>
                        </Row>
                    }
                    <ExtrasComponent extras={geofence.extras} readonly/>

                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Container>
                    <Row>
                        <Col>
                            <IconButton icon={faCopy} onClick={onCopy}/>
                            <IconButton icon={faTrashCan} color="red" onClick={onDelete}/>
                        </Col>
                    </Row>
                </Container>
            </Modal.Footer>
        </Modal>
    );
};

export default GeofenceActionsModal;